import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { fetchBlogPost } from "@/lib/api";
import { OrnamentalDivider } from "@/components/OrnamentalDivider";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchBlogPost(slug);
        setPost(data);
      } catch (_) {
        setNotFound(true);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <Loader2 className="mx-auto animate-spin text-[#6E2638]" size={32} />
      </div>
    );
  }
  if (notFound || !post) {
    return (
      <div className="max-w-3xl mx-auto px-6 py-24 text-center">
        <div className="serif text-4xl text-[#6E2638]">Story not found.</div>
        <Link to="/blog" className="btn-primary mt-6 inline-flex">Back to journal</Link>
      </div>
    );
  }

  return (
    <article data-testid="blog-post-page" className="max-w-3xl mx-auto px-6 lg:px-10 py-16">
      <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-[#6E2638] hover:underline" data-testid="blog-back">
        <ArrowLeft size={16} /> All stories
      </Link>

      <div className="stamp mt-6" data-testid="blog-post-date">
        {new Date(post.created_at).toLocaleDateString("en-AU", { year: "numeric", month: "long", day: "numeric" })}
      </div>
      <h1 className="serif text-4xl md:text-5xl text-[#6E2638] mt-4 leading-tight" data-testid="blog-post-title">
        {post.title}
      </h1>
      {post.excerpt && <p className="mt-4 text-lg text-[#1A1817]/80 italic">{post.excerpt}</p>}

      <OrnamentalDivider />

      {post.cover_image_url && (
        <img src={post.cover_image_url} alt={post.title}
             className="rounded-2xl w-full aspect-[16/9] object-cover sepia-soft my-8" />
      )}

      <div className="serif text-lg text-[#1A1817] leading-relaxed whitespace-pre-wrap" data-testid="blog-post-body">
        {post.body}
      </div>

      <div className="mt-16 border-t border-[#E5D9C5] pt-8 flex items-center justify-between">
        <Link to="/blog" className="btn-outline-gold">More stories</Link>
        <Link to="/individual" className="btn-primary">Book the walk</Link>
      </div>
    </article>
  );
}
